import classNames from 'classnames';
import React, { FC, forwardRef } from 'react';

import styles from './TransferOptionsButton.module.scss';
import { TransferOptionsIcon } from './TransferOptionsIcon';
import { TransferOptionsButtonProps } from './types';

export const TransferOptionsButton: FC<TransferOptionsButtonProps> = forwardRef<
  HTMLButtonElement,
  TransferOptionsButtonProps
>(({ className, color, ...props }, ref) => (
  <button ref={ref} className={classNames(styles.button, className)} {...props}>
    <TransferOptionsIcon fill={color} role="img" />
  </button>
));

TransferOptionsButton.displayName = 'TransferOptionsButton';
